<template>
    <div id="app" class="entry-page">
        <template v-if="initialized">
            <div class="pageOverlay" :class="{'visible': configurationSidebarOpen}"></div>
            <app-header/>
            <main :class="mainClasses">
                <app-sidebar/>
                <router-view
                        :key="$route.fullPath"
                />
            </main>
            <configs-sidebar/>

            <order-quote-modal
                    :visible.sync="orderQuoteModalVisible"
                    :error="offerQuoteModalError"
                    :outer-click-close="false"
                    :company-name="companyInfo.name"
                    :on-submit="handleSendOfferQuote"
            />

            <confirmation-modal
                    :visible.sync="confirmModalVisible"
                    :message="confirmModal.message"
                    :on-confirm="confirmModal.onConfirm"
            />
        </template>
    </div>
</template>

<script>
  import AppHeader from '@/components/AppHeader.vue'
  import AppSidebar from '@/components/AppSidebar.vue'
  import ConfigsSidebar from '@/components/configs-sidebar/Sidebar.vue'
  import OrderQuoteModal from '@/components/OrderQuoteModal.vue'
  import ConfirmationModal from '@/components/ConfirmationModal.vue'
  import { mapGetters, mapActions, mapState, mapMutations } from 'vuex'

  export default {
    name: 'App',
    beforeCreate () {
      this.$store.dispatch('init')
    },

    data () {
      return {
        offerQuoteModalError: null,
      }
    },
    metaInfo () {
      const { companyInfo, $t } = this
      return {
        title: companyInfo.seo_title + ' | ' + $t('titleWindowConfigurator'),
      }
    },
    methods: {
      ...mapActions({
        sendOfferQuote: 'configurator/sendOfferQuote',
      }),
      ...mapMutations({
        setConfirmModal: 'setConfirmModal',
        resetConfirmModal: 'resetConfirmModal',
      }),
      async handleSendOfferQuote (client) {
        const { $store, $t, $router, sendOfferQuote } = this

        try {
          this.offerQuoteModalError = null
          await sendOfferQuote({ client })
          $store.commit('setOrderQuoteModalVisible', false)
          $store.commit('setConfigurationSent', true)
          $store.commit('clearFiles')
          $store.commit('clearConfigurations')
        } catch (error) {
          this.offerQuoteModalError = $t('genericErrorMessage')
          throw error
        }
      },
    },
    computed: {
      ...mapState({
        initialized: state => state.initialized,
        companyInfo: state => state.companyInfo,
        confirmModal: state => state.confirmModal,
        configurationSidebarOpen: state => state.configurationsSidebar.open,
      }),
      ...mapGetters({
        completed: 'configurator/completed',
      }),
      mainClasses () {
        const { $route: { meta = {} }, completed } = this
        let classes = [
          'main',
          'main-shadow',
          'is-left-sidebar',
          'is-right-sidebar',
          'is-fixed-header',
        ]

        if (meta.mainClasses && Array.isArray(meta.mainClasses)) {
          classes = classes.concat(...meta.mainClasses)
        }

        if (completed) {
          let classesSummary = 'is-left-sidebar--home'
          classes = classes.concat(classesSummary)
        }

        return classes
      },

      orderQuoteModalVisible: {
        get () {
          return this.$store.state.orderQuoteModalVisible
        },
        set (val) {
          this.$store.commit('setOrderQuoteModalVisible', val)
        },
      },
      confirmModalVisible: {
        get () {
          return this.confirmModal.visible
        },
        set (val) {
          if (val === false) {
            this.resetConfirmModal()
          }
        },
      },
    },
    // watch: {
    //   'companyInfo.seo_title': {
    //     immediate: true,
    //     handler(value) {
    //       console.log(value);
    //       document.title = value || 'Internorm';
    //     },
    //   },
    // },
    components: {
      AppHeader,
      AppSidebar,
      ConfigsSidebar,
      OrderQuoteModal,
      ConfirmationModal,
    },
  }
</script>

<style scoped>
    @media (min-width: 991px) {
        .vertical-center {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100vh;
        }
    }
</style>

